/*
 *   File : link-text.js
 *   Author URI : https://evoqins.com
 *   Description : Link text button
 *   Integrations : null
 *   Version : v1.1
 */

/*import components*/
import Icon from "../Icon/icon";

/*import styles*/
import style from "../../Styles/Components/link-text.module.scss";
import { Fragment } from "react";

// type - 2 for blue text and type 1 for green 

const LinkText = ({
    onClick = () => null,
    iconPosition = 2,
    type,
    disabled,
    title,
    icon,
    className = "",
    toggle,
    target
}) => {
    return (
        <Fragment>
            {type === 2 ?
                <p className={
                    disabled ?
                        `color-primary-color e-poppins-medium e-font-14 line-height-24px mb-0 ${style.e_see_more_blue} ${className} ${style.e_disable}`
                        :
                        `color-primary-color e-poppins-medium e-font-14 line-height-24px mb-0 ${style.e_see_more_blue} ${className}`}
                    data-bs-toggle={toggle}
                    data-bs-target={target}
                    onClick={() => onClick()}>
                    {
                        iconPosition === 1 && (
                            <Icon icon={icon}
                                alt="See more"
                                width="24px"
                                height="24px"
                                className={`${style.e_icon} me-3 position-relative`} />
                        )
                    }
                    <span >{title ? title : "See more"}</span>
                    {
                        iconPosition === 2 && (
                            <Icon icon={icon}
                                alt="See more"
                                width="24px"
                                height="24px"
                                className={`${style.e_icon} ms-3 position-relative `} />
                        )
                    }
                </p>
                :
                <p className={`color-sea-green e-poppins-medium e-font-14 line-height-24px mb-0 ${style.e_see_more} ${className}`}
                    data-bs-toggle={toggle}
                    data-bs-target={target}
                    onClick={() => onClick()}>
                    {
                        iconPosition === 1 && (
                            <Icon icon={icon}
                                alt="See more"
                                width="24px"
                                height="24px"
                                className={`${style.e_icon} me-3 position-relative`} />
                        )
                    }
                    <span >{title ? title : "See more"}</span>
                    {
                        iconPosition === 2 && (
                            <Icon icon={icon}
                                alt="See more"
                                width="24px"
                                height="24px"
                                className={`${style.e_icon} ms-3 position-relative `} />
                        )
                    }
                </p>}
        </Fragment>
    )
}


export default LinkText